import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { useParams } from 'react-router-dom'
import { FaPlus, FaDollarSign, FaArrowLeft } from "react-icons/fa"
import AdminLayout from "../../../../components/AdminLayout"

//Components
import CardService from "../../../../services/card_services"

export function withRouter(Children) {
    return (props) => {
        const match = { params: useParams() };
        return <Children {...props} match={match} />
    }
}


class AdminNewBudSale extends Component {
    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            success: false,
            levels: [],
            bud_uuid: null,
            level: null,
            bud_name: null,
            description: '',
            img_url: null,
            sale_info: null,
            price: null,
            start_date: null,
            end_date: null,
            max_sales: null,

        }
    }

    componentDidMount = async () => {
        const { id } = this.props.match.params
        const buds = await CardService.getBuds()
        for (let bud of buds) {
            if (bud.bud_uuid === id) {
                this.setState({
                    level: bud.bud_level,
                    bud_name: bud.bud_name,
                    description: bud.description,
                    img_url: bud.img_url,
                    bud_uuid: id,
                    sale_info: bud.sale_info,
                    xp: 1,
                })
            }

        }
        const levels = await CardService.getLevels()
        this.setState({ levels })
    }

    newSale = async () => {
        if (!this.state.price || !this.state.end_date)
            NotificationManager.error('Missing information')
        else {
            try {
                this.setState({ processing: true })
                const data = await CardService.newBudSale(this.state.bud_uuid, this.state.price, this.state.max_sales,
                    this.state.start_date ? new Date(this.state.start_date).toISOString() : null, new Date(this.state.end_date).toISOString(),
                    this.state.xp)
                NotificationManager.success(data.message)
                this.setState({ processing: false, success: true })
            } catch (e) {
                this.setState({ processing: false })
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        const levelColors = {
            starter: "bg-gray-100 text-gray-700",
            common: "bg-green-100 text-green-700",
            rare: "bg-blue-100 text-blue-700",
            epic: "bg-purple-100 text-purple-700",
            legendary: "bg-orange-100 text-orange-700",
            mythic: "bg-red-100 text-red-700",
            eternal: "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        };

        return (
            <>
                <AdminLayout 
                    title="Create New Sale"
                    breadcrumbs={[
                        { label: 'Buds', href: '/admin/buds' },
                        { label: 'Details', href: `/admin/buds/details/${this.state.bud_uuid}` },
                        { label: 'New Sale' }
                    ]}
                >
                    <div className="max-w-4xl mx-auto space-y-6">
                        {/* Bud Info Card */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <div className="flex flex-col md:flex-row gap-6">
                                {this.state.img_url && (
                                    <div className="flex justify-center md:justify-start">
                                        <img 
                                            src={this.state.img_url} 
                                            alt={this.state.bud_name} 
                                            className="w-48 rounded-lg shadow-lg border-2 border-gray-300"
                                        />
                                    </div>
                                )}
                                <div className="flex-1 space-y-2">
                                    <div className="flex items-center gap-2">
                                        <h2 className="text-2xl font-bold text-gray-900">{this.state.bud_name}</h2>
                                        <span className={`px-3 py-1 rounded-lg text-xs font-bold ${levelColors[this.state.level]}`}>
                                            {this.state.level}
                                        </span>
                                    </div>
                                    {this.state.description.en && (
                                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                                            <p className="text-xs font-semibold text-blue-700 mb-1">EN</p>
                                            <p className="text-sm text-gray-800">{this.state.description.en}</p>
                                        </div>
                                    )}
                                    {this.state.description.fr && (
                                        <div className="bg-purple-50 border border-purple-200 rounded-lg p-3">
                                            <p className="text-xs font-semibold text-purple-700 mb-1">FR</p>
                                            <p className="text-sm text-gray-800">{this.state.description.fr}</p>
                                        </div>
                                    )}
                                    {!this.state.description.en && (
                                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                                            <p className="text-xs font-semibold text-gray-700 mb-1">Description</p>
                                            <p className="text-sm text-gray-800">{this.state.description}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Sale Form Card */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 space-y-4">
                            <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                                <FaDollarSign className="text-green-500" />
                                Sale Configuration
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* Price */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Sale Price (★) *</label>
                                    <input 
                                        type="number" 
                                        placeholder="Set sale price" 
                                        onChange={(e) => this.setState({ price: e.target.value })} 
                                        value={this.state.price || ''}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                {/* Start Date */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Start Date (Optional)</label>
                                    <input 
                                        type="datetime-local" 
                                        onChange={(e) => this.setState({ start_date: e.target.value })} 
                                        value={this.state.start_date || ''}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                {/* End Date */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">End Date *</label>
                                    <input 
                                        type="datetime-local" 
                                        onChange={(e) => this.setState({ end_date: e.target.value })} 
                                        value={this.state.end_date || ''}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                {/* Max Sales */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Max Sales (Optional)</label>
                                    <input 
                                        type="number" 
                                        placeholder="Leave empty for unlimited" 
                                        onChange={(e) => this.setState({ max_sales: e.target.value })} 
                                        value={this.state.max_sales || ''}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                {/* XP */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">XP Reward</label>
                                    <input 
                                        type="number" 
                                        placeholder="Set XP" 
                                        onChange={(e) => this.setState({ xp: e.target.value })} 
                                        value={this.state.xp || ''}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-end gap-3">
                            {this.state.processing ? (
                                <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg font-medium">
                                    Processing... Please wait
                                </div>
                            ) : this.state.success ? (
                                <button 
                                    onClick={() => window.location.href = `/admin/buds/details/${this.state.bud_uuid}`}
                                    className="px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-lg hover:from-gray-600 hover:to-gray-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaArrowLeft />
                                    Back to Details
                                </button>
                            ) : (
                                <button 
                                    onClick={this.newSale}
                                    className="px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaPlus />
                                    Create Sale
                                </button>
                            )}
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withRouter(AdminNewBudSale)